import { openSubInvoiceModal } from '../../../State/subInvoiceModal'

export default () => (dispatch) => {

  dispatch(openSubInvoiceModal())

}
